import { render, staticRenderFns } from "./round-diversity-3.vue?vue&type=template&id=a6b84180&"
import script from "./round-diversity-3.vue?vue&type=script&lang=js&"
export * from "./round-diversity-3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports